<div
  class="modal fade show d-block"
  tabindex="-1"
  (click)="closeModal()"
  style="
    background: rgba(15, 23, 42, 0.7);
    backdrop-filter: blur(8px);
    z-index: 1050;
  "
>
  <div
    class="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-md-down px-4"
    (click)="$event.stopPropagation()"
  >
    <div
      class="modal-content border-0 shadow-lg overflow-hidden"
      style="border-radius: 24px"
    >
      <div class="modal-body p-4 position-relative bg-white text-start">
        <button
          type="button"
          (click)="closeModal()"
          class="position-absolute border-0 d-flex align-items-center justify-content-center shadow-sm"
          style="
            top: 20px;
            right: 20px;
            background-color: #0f172a;
            color: white;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            transition: 0.3s;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 class="fw-bold mb-3" style="color: #0f172a; font-size: 28px">
          Submit Application
        </h2>

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="row g-3">
            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >First name*</label
              >
              <input
                type="text"
                formControlName="senderFirstName"
                placeholder="John"
                class="form-control border-0 p-2 shadow-none"
                [style.border]="
                  isSubmitted && contactForm.get('senderFirstName')?.invalid
                    ? '1px solid #dc3545 !important'
                    : '1px solid #e2e8f0 !important'
                "
                style="background-color: #f8fafc; border-radius: 8px"
              />
              @if (isSubmitted && contactForm.get('senderFirstName')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                Please enter a valid first name.
              </div>
              }
            </div>

            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >Last name*</label
              >
              <input
                type="text"
                formControlName="senderLastName"
                placeholder="Example: Doe"
                class="form-control border-0 p-2 shadow-none"
                [style.border]="
                  isSubmitted && contactForm.get('senderLastName')?.invalid
                    ? '1px solid #dc3545 !important'
                    : '1px solid #e2e8f0 !important'
                "
                style="background-color: #f8fafc; border-radius: 8px"
              />
              @if (isSubmitted && contactForm.get('senderLastName')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                Please enter a valid last name.
              </div>
              }
            </div>

            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >Email*</label
              >
              <input
                type="email"
                formControlName="senderEmail"
                placeholder="Example: johndoe@email.com"
                class="form-control border-0 p-2 shadow-none"
                [style.border]="
                  isSubmitted && contactForm.get('senderEmail')?.invalid
                    ? '1px solid #dc3545 !important'
                    : '1px solid #e2e8f0 !important'
                "
                style="background-color: #f8fafc; border-radius: 8px"
              />
              @if (isSubmitted && contactForm.get('senderEmail')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                Enter a valid email address.
              </div>
              }
            </div>

            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >Phone number*</label
              >
              <div class="d-flex gap-2">
                <div
                  class="d-flex align-items-center px-2 border rounded-3"
                  style="
                    background-color: #f8fafc;
                    border: 1px solid #e2e8f0 !important;
                  "
                >
                  <span style="font-size: 14px">🇮🇹</span>
                  <select
                    formControlName="countryCode"
                    class="border-0 bg-transparent outline-none fw-medium"
                    style="font-size: 12px"
                  >
                    <option value="IT">IT</option>
                    <option value="EG">EG</option>
                  </select>
                </div>
                <input
                  type="text"
                  formControlName="mobilePhone"
                  placeholder="+39"
                  class="form-control border-0 p-2 shadow-none"
                  [style.border]="
                    isSubmitted && contactForm.get('mobilePhone')?.invalid
                      ? '1px solid #dc3545 !important'
                      : '1px solid #e2e8f0 !important'
                  "
                  style="background-color: #f8fafc; border-radius: 8px"
                />
              </div>
              @if (isSubmitted && contactForm.get('mobilePhone')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                Phone number is required.
              </div>
              }
            </div>

            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >Linkedin Profile*</label
              >
              <textarea
                formControlName="emailBody"
                placeholder="Paste your linkedin profile here.."
                class="form-control border-0 p-2 shadow-none"
                [style.border]="
                  isSubmitted && contactForm.get('emailBody')?.invalid
                    ? '1px solid #dc3545 !important'
                    : '1px solid #e2e8f0 !important'
                "
                style="
                  background-color: #f8fafc;
                  border-radius: 8px;
                  height: 80px;
                  resize: none;
                "
              ></textarea>
              @if (isSubmitted && contactForm.get('emailBody')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                Valid profile link is required.
              </div>
              }
            </div>

            <div class="col-md-6">
              <label
                class="form-label fw-bold mb-1"
                style="color: #0f172a; font-size: 13px"
                >Upload CV*</label
              >
              <div
                class="position-relative d-flex justify-content-between align-items-center p-2 w-100 shadow-none"
                [style.border]="
                  isSubmitted && contactForm.get('cvFile')?.invalid
                    ? '1px solid #dc3545 !important'
                    : '1px solid #e2e8f0 !important'
                "
                style="
                  background-color: #f8fafc;
                  border-radius: 8px;
                  cursor: pointer;
                "
              >
                <input
                  type="file"
                  accept=".pdf"
                  (change)="onFileChange($event)"
                  class="position-absolute opacity-0 w-100 h-100 top-0 start-0"
                  style="cursor: pointer"
                />
                <span style="color: #94a3b8; font-size: 13px">{{
                  contactForm.get("cvFile")?.value?.name ||
                    "Upload your CV (PDF only)"
                }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#94a3b8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                  />
                </svg>
              </div>
              @if (isSubmitted && contactForm.get('cvFile')?.invalid) {
              <div class="text-danger" style="font-size: 11px; margin-top: 2px">
                CV is required.
              </div>
              }
            </div>
          </div>

          <div class="d-flex justify-content-end mt-4">
            <button
              type="submit"
              class="btn text-white fw-bold py-3 px-3 border-0"
              style="
                background-color: #38bdf8;
                border-radius: 12px;
                transition: 0.3s;
              "
            >
              Submit Application
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
